module.exports = __webpack_public_path__ + "img/tadahiro.32d5f92d.jpg";